import React from 'react';
import { useCart } from './CartContext';
import { useNavigate } from 'react-router-dom';
import '../styles/CartDrawer.css';

interface CartDrawerProps {
  open: boolean;
  onClose: () => void;
}

const CartDrawer: React.FC<CartDrawerProps> = ({ open, onClose }) => {
  const { cart, loading, updateQuantity, removeItem } = useCart();
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <>
      <div className="cart-overlay" onClick={onClose} />
      <aside className="cart-drawer">
        <div className="cart-drawer-header">
          <h2>Shopping Cart</h2>
          <button className="cart-close-btn" onClick={onClose} type="button">&times;</button>
        </div>

        {loading && <div className="cart-loading">Loading...</div>}

        {!loading && (!cart || cart.items.length === 0) && (
          <div className="cart-empty">
            <p>Your cart is empty</p>
          </div>
        )}

        {!loading && cart && cart.items.length > 0 && (
          <>
            <div className="cart-items">
              {cart.items.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-info">
                    <strong>{item.productName}</strong>
                    <span className="cart-item-price">${item.unitPrice.toFixed(2)}</span>
                  </div>
                  <div className="cart-item-controls">
                    <button onClick={() => updateQuantity(item.id, item.quantity - 1)} disabled={item.quantity <= 1}>−</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                    <button className="cart-remove-btn" onClick={() => removeItem(item.id)}>✕</button>
                  </div>
                  <div className="cart-item-subtotal">
                    ${item.subtotal.toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
            <div className="cart-footer">
              <div className="cart-total">
                <span>Total</span>
                <strong>${cart.total.toFixed(2)}</strong>
              </div>
              <button
                className="cart-checkout-btn"
                onClick={() => { onClose(); navigate('/checkout'); }}
              >
                Proceed to Checkout
              </button>
            </div>
          </>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
